import React, { useState, useEffect, useCallback } from 'react'
import { Heading, Table, Button, Dialog, toaster, Pane, FormField, TextInput, Text } from 'evergreen-ui'
import EmployeeEmailForm from '../../Components/EmployeeEmailForm'
import axios from '../../Utils/axios';
import BtnDefault from '../../Components/BtnDefault';
import moment from 'moment';

const EmployeeEmail = () => {
  const [employees, setEmployees] = useState([])
  const [addNewEmails, setAddNewEmails] = useState(null)
  const [editEmails, setEditEmails] = useState(null)
  const [sendReport, setSendReport] = useState(null)
  const [deleteEmailConfig, setDeleteEmailConfig] = useState(null)
  const [dates, setDates] = useState({
    dateFrom: moment().subtract(10, 'days').format('YYYY-MM-DD'),
    dateTo: moment().format('YYYY-MM-DD')
  })

  const getEmployees = useCallback(async () => {
    try {
      const fetchEmployeeList = await axios.get(`/company/employees`) 
      const fetchEmployeeConfig = await axios.get(`/company/activities/scheduled-reports`)
      const reportConfig = fetchEmployeeConfig.data.results 
      const result = fetchEmployeeList.data.employees.map(employee => 
        ({...employee, reportConfig: reportConfig.find(config => config.employee === employee.__id__)})
      )
      setEmployees(result)
    }
    catch (error) {
      toaster.danger('Falha ao buscar dados')
    }
  }, [])

  function handleDelete(id){
    setDeleteEmailConfig(id)
  }

  async function handleDeleteEmailConfigs(id){
    try {
      const { status } = await axios.delete(`/company/activities/scheduled-reports/${id}`)
      if (status === 200) {
        toaster.success('E-mail excluído com sucesso')
        setDeleteEmailConfig(null)
        getEmployees()
      }
    }
    catch (error) {
      toaster.danger(error.response.data.error.message)
    } 
  }

  async function handleAddEmailConfigs(id, emails){ 
    const emailsToArray = emails.split(',')
    try {
      const { status } = await axios.post(`/company/activities/scheduled-reports`, {
        employee: id,
        ccs: emailsToArray
      })
      if (status === 201) {
        toaster.success('E-mail adicionado com sucesso')
        setAddNewEmails(null)
        getEmployees()
      }
    }
    catch (error) {
      toaster.danger(error.response.data.error.message)
    } 
  }

  async function handleEditEmailConfigs(id, newEmails){ //ARRUMAR A ROTA
    if (newEmails === ''){
      return toaster.warning('E-mail não alterado')
    }
    const emailsToArray = newEmails.split(',')

    try {
      const { status } = await axios.put(`/company/activities/scheduled-reports/${id}`, {
        ccs: emailsToArray
      })
      if (status === 200) {
        toaster.success('E-mail adicionado com sucesso')
        setEditEmails(null)
        getEmployees()
      }
    }
    catch (error) {
      toaster.danger(error.response.data.error.message)
    } 
  }

  async function handleSendReportByEmail(id, dates){
    const formatedDateFrom = moment(dates.dateFrom).format('YYYY-MM-DD 00:00:00')
    const formatedDateTo = moment(dates.dateTo).format('YYYY-MM-DD 23:59:59')
   try {
     const { status } = await axios.post(`/company/activities/scheduled-reports/${id}/actions/send`, {
      from_date: formatedDateFrom,
      to_date: formatedDateTo
     })
     if (status === 200) {
       toaster.success('E-mail enviado com sucesso')
       setSendReport(null)
       getEmployees()
     }
   }
   catch (error) {
     toaster.danger(error.response.data.error.message)
   } 
  }

  const setValues = ({ target }) => {
    if (target.name === 'dateFrom' && moment(target.value).diff(dates.dateTo) > 0) {
      return toaster.danger('Data de início não pode ser superior a data de término', {
        duration: 3
      })
    }
    setDates({
      ...dates,
      [target.name]: target.value
    })
  }
console.log(sendReport)
  useEffect(() => {
    getEmployees()
  }, [getEmployees])

  return (
    <div>
      <Heading size={600}>
        Configuração de envio de relatório de atividades por e-mail
      </Heading>

      <Table style={{ marginTop: 15 }}>
        <Table.Head>
          <Table.TextHeaderCell>
            Nome
          </Table.TextHeaderCell>
          <Table.TextHeaderCell>
            E-mail
          </Table.TextHeaderCell>
          <Table.TextHeaderCell width={400} flex="none">
            Ações
          </Table.TextHeaderCell>
        </Table.Head>
        <Table.VirtualBody height={'90vh'}>
          {employees.map((employee) => {
            const reportConfig = employee.reportConfig || null
            return (
            <Table.Row key={employee.__id__}>
              <Table.TextCell>{employee.name}</Table.TextCell>
              <Table.TextCell>{reportConfig && reportConfig.ccs.join(',')}</Table.TextCell>
              <Table.TextCell width={600} flex='none'>
                {!reportConfig &&
                  <Button
                    iconBefore='add'
                    marginRight={20}
                    onClick={() => setAddNewEmails(employee)}
                  > Adicionar </Button>
                }  
                {!!reportConfig &&
                  <Button
                    iconBefore='edit'
                    marginRight={20}
                    onClick={() => setEditEmails(reportConfig && reportConfig)}
                  > <span style={{width: 51}}>
                      Editar
                    </span></Button>
                }
                <Button
                  disabled={!reportConfig}
                  iconBefore='trash'
                  marginRight={20}
                  onClick={() => handleDelete(reportConfig && reportConfig.__id__)}
                > Excluir </Button>
                
                <Button
                  disabled={!reportConfig}
                  iconBefore='envelope'
                  marginRight={20}
                  onClick={()=> setSendReport(employee)}
                > Enviar relatório </Button>

              </Table.TextCell>
            </Table.Row>
          )})}
        </Table.VirtualBody>
      </Table >

      { addNewEmails && (
        <Dialog
          shouldCloseOnOverlayClick={false}
          isShown={!!addNewEmails}
          title="Configurar e-mail"
          onCloseComplete={() => setAddNewEmails(null)}
          hasFooter={false}
        >
            <EmployeeEmailForm
              emailConfigId={addNewEmails.__id__}
              addEmailConfigs={handleAddEmailConfigs} 
              />
        </Dialog>
        )
      } 

      { editEmails && (
        <Dialog
          shouldCloseOnOverlayClick={false}
          isShown={!!editEmails}
          title="Editar e-mails"
          onCloseComplete={() => setEditEmails(null)}
          hasFooter={false}
        >
          <EmployeeEmailForm
            emailConfigData={editEmails}
            editEmailConfigs={handleEditEmailConfigs} 
          />
        </Dialog>
        )
      } 
      
      { sendReport && (
        <Dialog
          shouldCloseOnOverlayClick={false}
          isShown={!!sendReport}
          title="Enviar relatório por e-mail"
          onCloseComplete={() => setSendReport(null)}
          hasFooter={false}
          width={700}
        >
          <div style={{ marginLeft: 10, marginRight: 10, marginTop: 0, marginBottom: 20, display: 'block' }}>
            <Pane display="flex" padding={16} borderRadius={3}>
              <Pane flex={1} alignItems="center" display="flex">
                <FormField
                  label='Data Início'
                >
                  <TextInput
                    type='date'
                    placeholder='Data inicio'
                    name='dateFrom'
                    value={dates.dateFrom}
                    onChange={setValues}

                  />
                </FormField>
              </Pane>
              <Pane flex={1} alignItems="center" display="flex">
                <FormField
                  label='Data Término'
                >
                  <TextInput
                    type='date'
                    placeholder='Data inicio'
                    name='dateTo'
                    onChange={setValues}
                    value={dates.dateTo}
                  />
                </FormField>
              </Pane>
            </Pane>
          </div>
          
          <BtnDefault
          type='button'
          onClick={() => handleSendReportByEmail(sendReport.reportConfig.__id__, dates)}
          appearance='primary' icon='envelope'
          >
            Enviar
          </BtnDefault>
        </Dialog>
        )
      } 

        <Dialog
          shouldCloseOnOverlayClick={false}
          isShown={!!deleteEmailConfig}
          title="Excluir configuração do usuário"
          onCloseComplete={() => setDeleteEmailConfig(null)}
          onConfirm={() => handleDeleteEmailConfigs(deleteEmailConfig)}
          onCancel={() => setDeleteEmailConfig(null)}
          confirmLabel="Remover"
          cancelLabel="Cancelar"
          hasFooter={true}
        >
          <Text>Tem certeza que deseja excluir a configuração desse usuário?</Text>

        </Dialog>
    </div>
  )
}

export default EmployeeEmail